import setMultiChoiceOptionHeights from './search_filters/multi-choice-filter';

function filterForm(){

  const filterForm = $('.filter-form');
  const filterButton = $('.filter-form-toggle');

  const valueSetter = () => {

    const filtersThatShouldNotBeCounted = ['order', 'location_id', 'search_radius'];

    const filtersCount = filterForm.serializeArray().reduce(( accumulator, item ) => {

      if (filtersThatShouldNotBeCounted.includes(getFilterLogicalName(item.name))) {
        return accumulator;
      }

      let value = item.value;

      if (typeof value === 'string') {
        value = value.trim();
      }

      return value !== '' ? accumulator + 1 : accumulator;
    }, 0);

    const filterFormValue = filterButton.find('.filter-form-value');

    // Reset value
    filterFormValue.text('');

    if ( filtersCount > 0 ) {
      // Set value if values count > 0
      filterFormValue.text(`(${filtersCount})`);
    }
  };

  function getFilterLogicalName(name) {
    const match = name.match(/^filters\[\d+]\[([^\]]+)]$/);
    return match ? match[1] : name;
  }

  if ( filterButton.length ) {
    // Init filter toggle click
    filterButton.click(function(){
      var btn = $(this);
      btn.next().stop().slideToggle('fast', () => {
        if ( btn.next().is(':hidden') ) {
          btn.next().removeAttr('style');
        } else {
          setMultiChoiceOptionHeights();
        }
      });
    });

    // Filtered value setter
    valueSetter();
    filterForm.change( valueSetter );
  }

}

$(filterForm);
